<template>
    <gmap-map
        ref="googleMap"
        id="googleMap"
        :style="`width: ${input_map_width}; height: ${input_map_height}`"
        :center="input_map_center"
        :zoom="input_map_zoom"
        :options="mapOptions"
    >
        <gmap-marker
            :icon="markerIcon"
            :position="markerCenter"
            :clickable="true"
            :draggable="false"
        >
        </gmap-marker>
    </gmap-map>
</template>

<script>
    export default {
        name: "GoogleMap",
        props: {
            input_map_height: {
                type: String,
                required: true,
                default: '10rem'
            },
            input_map_width: {
                type: String,
                required: false,
                default: '100%'
            },
            input_map_center: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        lat: 25.941755221982877,
                        lng: -80.12106550242612,
                    }
                }
            },
            input_map_center_default: {
                type: Boolean,
                required: false,
                default: false
            },
            input_map_zoom: {
                type: Number,
                required: false,
                default: 8
            },
            input_map_draggable: {
                type: Boolean,
                required: false
            },
            input_map_zoom_control: {
                type: Boolean,
                required: false
            },
            input_map_street_view_control: {
                type: Boolean,
                required: false
            },
            input_map_fullscreen_control: {
                type: Boolean,
                required: false
            },

            input_marker_center: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        lat: 25.941755221982877,
                        lng: -80.12106550242612,
                    }
                }
            },
            input_marker_image: {
                type: String,
                required: false
            },
            input_marker_dimensions: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        width: 35,
                        height: 55,
                    }
                }
            },
        },
        data() {
            return {
                mapOptions: {
                    minZoom: 3,
                    maxZoom: 20,
                    draggable: this.input_map_draggable ? this.input_map_draggable : false,
                    clickableIcons: false,
                    zoomControl: this.input_map_zoom_control ? this.input_map_zoom_control : false,
                    panControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: this.input_map_street_view_control ? this.input_map_street_view_control : false,
                    overviewMapControl: false,
                    rotateControl: false,
                    disableDefaultUI: false,
                    fullscreenControl: this.input_map_fullscreen_control ? this.input_map_fullscreen_control : false,
                    enableCloseButton: false,
                },
                markerCenter: this.input_marker_center,
                markerIcon: {
                    url: this.input_marker_image,
                    scaledSize: this.input_marker_dimensions,
                },
            }
        },
        mounted() {
            if (this.input_map_center_default) this.markerCenter = this.input_map_center;
        }
    }
</script>

<style>
    .gm-style .gm-style-iw {
        overflow: unset !important;
    }
    .gm-style-iw-c {
        padding-left: 0 !important;
        padding-right: 0 !important;
        border-radius: unset !important;
        max-width: 24.375rem !important;
        overflow: unset !important;
        box-shadow: -8px 5px 30px 15px rgba(0,0,0,.28)  !important;
    }
    .gm-style .gm-style-iw-t::after {
        content: none !important;
    }
    .gm-style .gm-style-iw-t::before {
        content: none !important;
    }
    .gm-style-iw-d {
        overflow-x: hidden !important;
        box-shadow: 24px 32px 34px -24px rgba(0,0,0,0.28) !important;
    }
</style>
